/**
 * Headline numbers from scripts/btc15-maker-backtest.ts, recorded by hand
 * when the strategy was locked, so the Market Maker page can show the
 * backtest next to the forward test. Full results: docs/MARKET_MAKER.md.
 */
export interface MakerBacktestSnapshot {
  window: string;
  rounds: number;
  settlementCents: number;
  pessimisticPnl: number;
  optimisticPnl: number;
  note: string;
}

export const MAKER_BACKTEST: MakerBacktestSnapshot | null = {
  window: 'Oct 7–14, 2026',
  rounds: 662,
  settlementCents: 0.19,
  pessimisticPnl: -154.77,
  optimisticPnl: -9.94,
  note: 'Quotes earned the 1¢ spread ($28 pessimistic, $49 optimistic) and gave back more on inventory left holding the losing side ($183 and $59). Both fill rules lost in both halves; even the optimistic 95% range per round was below zero.',
};
